import { useEffect, useState } from 'react';
import { CartSuggestion, getCartSuggestions } from '../Utils/cartApi';

export function useCartSuggestions(empresaid: string, produtos: any[], agendamento: any) {
  const [suggestions, setSuggestions] = useState<CartSuggestion[]>([]);
  const scheduleKey = JSON.stringify(agendamento || null);
  useEffect(() => {
    setSuggestions([]);
    if (!empresaid || !produtos?.length) return;
    const controller = new AbortController();
    let current = true;
    const timer = window.setTimeout(() => {
      getCartSuggestions(empresaid, produtos, JSON.parse(scheduleKey), controller.signal)
        .then(items => { if (current) setSuggestions(items); })
        .catch(() => { if (current) setSuggestions([]); });
    }, 300);
    return () => { current = false; controller.abort(); window.clearTimeout(timer); };
  }, [empresaid, produtos, scheduleKey]);
  return suggestions;
}
